<template>
    <div style="line-height: 1.7em;">
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box card" flat v-if="leraner_marksheet != ''">
            <v-row dense>
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                        left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <v-row justify="center">
                    <v-col cols="12" sm="2" md="2">
                        <v-row v-if="org_basic_data.school_logo" dense justify="center">
                            <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="8" md="8">
                        <v-row v-if="org_basic_data.trust_name" dense justify="center">
                            <strong>
                                <h4>{{ org_basic_data.trust_name }}</h4>
                            </strong>
                        </v-row>
                        <v-row dense v-if="org_basic_data.school_name" justify="center">
                            <strong>
                                <h1>{{ org_basic_data.school_name }}</h1>
                            </strong>
                        </v-row>
                        <v-row v-if="org_basic_data.address" dense justify="center">
                            <h4>{{ org_basic_data.address }}</h4>
                        </v-row>
                        <v-row dense justify="center" v-if="org_basic_data.email && org_basic_data.phone">
                            <h4>
                                Phone : {{ org_basic_data.phone }} <span class="pl-2"></span> Email : {{
                                org_basic_data.email }}
                            </h4>
                        </v-row>
                        <v-row v-if="org_basic_data.website" dense justify="center">
                            <h4>Website : {{ org_basic_data.website }}</h4>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-row v-if="org_basic_data.trust_logo" dense justify="center">
                            <img :src="org_basic_data.trust_logo" width="75%" alt="logo" />
                            <!-- 1130534 -->
                            <span v-if="org_basic_data.cbsc_no">
                                <h5>CBSE Affiliation No. - {{ org_basic_data.cbsc_no }}</h5>
                            </span>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row dense justify="center" class="tech-remark" style="margin-top: -10px;">
                    <span class="text_report">
                        <strong><v-col cols="12" sm="12" md="12"> Report Card A.Y. {{ ay }}</v-col> </strong>
                    </span>
                </v-row>
                <v-row dense style="margin-top: -20px;">
                    <v-col cols="12" sm="10" md="10">
                        <!-- <v-row dense>
                          <v-col cols="12" sm="2" md="2"> <strong>Roll No. : </strong> {{roll_no}} </v-col>
                          <v-col cols="12" sm="3" md="3"><strong>Name : </strong> {{name}} </v-col>
                          <v-col cols="12" sm="2" md="2"><strong>Grade : </strong>{{standard}} </v-col>
                          <v-col cols="12" sm="2" md="2"><strong>Section : </strong>{{div}} </v-col>
                      </v-row>
                      <v-row dense>
                          <v-col cols="12" sm="6" md="6"> <strong>Mother's Name : </strong> {{mother_name}} </v-col>
                          <v-col cols="12" sm="6" md="6"><strong>Father's Name : </strong> {{father_full_name}} </v-col>
                      </v-row>
                       <v-row dense>
                          <v-col cols="12" sm="6" md="6"> <strong>Date Of Birth : </strong> {{dob}} </v-col>
                          <v-col cols="12" sm="6" md="6"> <strong>G.R. No. : </strong>  {{gr_no}}</v-col>
                      </v-row>
                       <v-row dense>
                          <v-col cols="12" sm="12" md="12"> <strong>Address : </strong> {{address}} </v-col>
                      </v-row>
                      <v-row dense>
                          <v-col cols="12" sm="6" md="6"><strong>Telephone No. : </strong> {{mobile_no}} </v-col>
                      </v-row> -->
                        <br />
                        <v-row class="stud-info" dense>
                            <v-col cols="12" sm="6" md="6"><strong>Name : </strong> {{ name }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Roll No. : </strong> {{ roll_no }} </v-col>
                            <v-col cols="12" sm="6" md="6"><strong>Grade & Section : </strong>{{ standard }} {{ div }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6"><strong>PRN : </strong>{{ reg_no }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Date Of Birth : </strong> {{ dob }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>G.R. No. : </strong> {{ gr_no }}</v-col>
                            <v-col cols="12" sm="6" md="6"><strong>Father's Name : </strong> {{ father_full_name }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6"><strong>Father's Contact No. : </strong> {{ father_contact }}
                            </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Mother's Name : </strong> {{ mother_name }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Mother's Contact No. : </strong> {{ mother_contact
                                }} </v-col>
                            <v-col cols="12" sm="12" md="12"> <strong>Residential Address : </strong> {{ address }}
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="photo != null">
                        <img class="ml-5 mt-6" :src="awspath + photo" style="width: 160px; height: 160px;" alt="logo" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-else>
                        <img class="ml-5" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg"
                            style="width: 160px; height: 160px;" alt="logo" />
                    </v-col>
                </v-row>
            </v-col>
            <!-- <br /> -->
            <!-- <v-col cols="12" sm="12" md="12"> -->
            <div style="" class="div">
                <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <td>
                                <center>Scholastic Areas</center>
                            </td>
                            <td :colspan="
                leraner_marksheet.ass_details_for_marksheet_22_23.length * 2 +
                2
              ">
                                <center>
                                    <center>
                                        Assessment for the Academic Year {{ ay }} <br />
                                        ( {{ leraner_marksheet.sem1 }} & {{ leraner_marksheet.sem2 }} )
                                    </center>
                                </center>
                            </td>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <td rowspan="2" class="">
                                <center>Subject Name</center>
                            </td>
                            <td colspan="2" class="" v-for="header in leraner_marksheet.ass_details_for_marksheet_22_23"
                                :key="header">
                                <center>
                                    <center>
                                        {{ header.name }} <br />
                                        {{ header.marks }}
                                    </center>
                                </center>
                            </td>
                            <td rowspan="2">
                                <center>
                                    Marks Obtained <br />
                                    (100)
                                </center>
                            </td>
                            <td rowspan="2">
                                <center>Grade</center>
                            </td>
                        </tr>
                        <tr>
                            <!-- <td></td> -->
                            <!-- <td class="" v-for="header in leraner_marksheet.ass_details_for_marksheet_22_23" :key="header">
                                  <center>{{ header }}</center>
                              </td> -->
                            <td v-for="(header, index) in leraner_marksheet
                .ass_details_for_marksheet_22_23.length * 2" :key="index">
                                <span v-if="header % 2 == 0">Marks Obtd.</span>
                                <!-- <span v-else-if="header % 1 == 1"> Marks Obtained </span> -->
                                <span v-else> Max. Marks </span>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(
              s, index
            ) in leraner_marksheet.learner_marksheet_data_scholastic" :key="index">
                            <td class="sub-td">
                                <!-- <center> -->
                                {{ index }}
                                <!-- </center> -->
                            </td>
                            <td v-for="(sem1, index1) in s[0]" :key="index1">
                                <center>{{ sem1 }}</center>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
            <br />
            <v-row dense justify="center">
                <span class="text_report" style="width: 30%;font-size: larger;">
                    <strong><v-col cols="12" sm="12" md="12">
                            <center> Overall Grade (All Subject) : {{ leraner_marksheet.overall_grade }}</center>
                        </v-col> </strong>
                </span>
            </v-row>
            <!-- <br /> -->
            <v-col cols="12" sm="12" md="12">
                <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <td colspan="4">
                                <center>Co-Scholastic Areas</center>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <center>{{ leraner_marksheet.sem1 }}</center>
                            </td>
                            <td>
                                <center>Grade</center>
                            </td>
                            <td>
                                <center>{{ leraner_marksheet.sem2 }}</center>
                            </td>
                            <td>
                                <center>Grade</center>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(
              s, index2
            ) in leraner_marksheet.leraner_coscholastic_marksheet" :key="index2">
                            <td>
                                <center>{{ index2 }}</center>
                            </td>
                            <td v-for="(sem1, index1) in s[0]" :key="index1">
                                <center>{{ sem1 }}</center>
                            </td>
                            <td>
                                <center>{{ index2 }}</center>
                            </td>
                            <td v-for="(sem2, index3) in s[1]" :key="index3">
                                <center>{{ sem2 }}</center>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <br />
            <v-col cols="12" sm="12" md="12">
                <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <td>
                                <center>{{ leraner_marksheet.sem1 }}</center>
                            </td>
                            <td>
                                <center>Grade</center>
                            </td>
                            <td>
                                <center>{{ leraner_marksheet.sem2 }}</center>
                            </td>
                            <td>
                                <center>Grade</center>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index2) in leraner_marksheet.leraner_other_marksheet" :key="index2">
                            <td>
                                <center>{{ index2 }}</center>
                            </td>
                            <td v-for="(sem1, index1) in s[0]" :key="index1">
                                <center>{{ sem1 }}</center>
                            </td>
                            <td>
                                <center>{{ index2 }}</center>
                            </td>
                            <td v-for="(sem2, index3) in s[1]" :key="index3">
                                <center>{{ sem2 }}</center>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="leraner_marksheet.display_bmi == 'True'">
                <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <!-- <thead> -->
                    <tr>
                        <td rowspan="3">
                            <center><strong>Health Status</strong></center>
                        </td>
                        <td colspan="3">
                            <center>
                                <strong>{{ leraner_marksheet.sem1 }}</strong>
                            </center>
                        </td>
                        <td colspan="3">
                            <center>
                                <strong>{{ leraner_marksheet.sem2 }}</strong>
                            </center>
                        </td>
                    </tr>
                    <!-- </thead>
                      <tbody> -->
                    <tr>
                        <td>
                            <center>Height (cm)</center>
                        </td>
                        <td>
                            <center>Weight (kg)</center>
                        </td>
                        <td>
                            <center>BMI</center>
                        </td>
                        <td>
                            <center>Height (cm)</center>
                        </td>
                        <td>
                            <center>Weight (kg)</center>
                        </td>
                        <td>
                            <center>BMI</center>
                        </td>
                    </tr>
                    <tr>
                        <td v-for="(s, index2) in leraner_marksheet.user_bmi_list_sem1" :key="index2">
                            <center>{{ s }}</center>
                        </td>
                        <td v-for="(s, index2) in leraner_marksheet.user_bmi_list_sem2" :key="index2">
                            <center>{{ s }}</center>
                        </td>
                    </tr>
                    <!-- </tbody> -->
                </v-simple-table>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="leraner_marksheet.display_att == 'True'">
                <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <td>
                                <center>Attendance</center>
                            </td>
                            <td>
                                <center>{{ leraner_marksheet.sem1 }}</center>
                            </td>
                            <td>
                                <center>{{ leraner_marksheet.sem2 }}</center>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <center>
                                    <strong>Total Attendance of the Student</strong>
                                </center>
                            </td>
                            <td v-for="(s, index2) in leraner_marksheet.sem1_attendance" :key="index2">
                                <center>{{ s.present }} / {{ s.total_working_stud }}</center>
                            </td>
                            <td v-for="(s, index2) in leraner_marksheet.sem2_attendance" :key="index2">
                                <center>{{ s.present }} / {{ s.total_working_stud }}</center>
                            </td>
                        </tr>
                        <!-- <tr>
                          <td>
                              <center><strong>Total Working Days</strong></center>
                          </td>
                          <td v-for="(s, index2) in leraner_marksheet.sem1_attendance" :key="index2">
                              <center>{{ s.total_working_stud }}</center>
                          </td>
                          <td v-for="(s, index2) in leraner_marksheet.sem2_attendance" :key="index2">
                              <center>{{ s.total_working_stud }}</center>
                          </td>
                      </tr> -->
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="tech-remark">
                <strong>Class Teacher's Remarks : </strong>
                {{ leraner_marksheet.lms_remark }}
            </v-col>
            <br>
            <v-row class="ml-5 tech-remark" dense justify="center" v-if="standard != 'X'">
                <v-col cols="12" sm="6" md="6">
                    <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px;">{{ name }} </span>
                    <span v-if="standard != 'X'">
                        is Passed and Promoted to
                        <span style="border-bottom: 3px solid #000; padding-bottom: 3px;">Grade {{
                            leraner_marksheet.next_std }}</span>
                    </span>
                </v-col>
                <v-col cols="12" sm="6" md="6" v-if="standard != 'X'">
                    New session begins on :
                    <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px;">{{
                        leraner_marksheet.sessiondate_std }}</span>
                </v-col>
                <br />
                <br />
            </v-row>
            <br />
            <br />
            <br />
            <br />
            <v-col cols="12" sm="12" md="12">
                <v-row dense justify="center" class="tech-remark">
                    <v-col cols="12" sm="4" md="4">
                        Date : {{ leraner_marksheet.lms_result_date }}
                    </v-col>
                    <v-col cols="12" sm="4" md="4"> Signature of Class Teacher </v-col>
                    <v-col cols="12" sm="4" md="4"> Signature of Principal </v-col>
                </v-row>
            </v-col>
            <v-container fill-height>
                <v-row dense justify="center" align="center" class="full-height">
                    <div class="pagebreak">
                        <v-row dense justify="center">
                            <span class="text_report">
                                <strong><v-col cols="12" sm="12" md="12" style="width: 400px;"> Scholastic Area (Grading
                                        on {{ leraner_marksheet.scholastic_grade }} Point Scale)</v-col> </strong>
                            </span>
                        </v-row>
                        <v-row dense justify="center">
                            <v-simple-table fixed-header dense class="elevation-1" style="width: 400px;">
                                <thead>
                                    <tr>
                                        <td class="">
                                            <center>Sr.No.</center>
                                        </td>
                                        <td class="">
                                            <center>Grade Name</center>
                                        </td>
                                        <td class="">
                                            <center>Percentage Range</center>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(s, index) in leraner_marksheet.grade_details" :key="s.g_id">
                                        <td>
                                            <center>{{ index + 1 }}</center>
                                        </td>
                                        <td>
                                            <center>{{ s.gradename }}</center>
                                        </td>
                                        <td>
                                            <center>{{ s.range }}</center>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-row>
                        <v-row dense justify="center" v-if="leraner_marksheet.cograde_details.length > 0">
                            <span class="text_report">
                                <strong><v-col cols="12" sm="12" md="12" style="width: 400px;"> Co-Scholastic Area
                                        (Grading on {{ leraner_marksheet.coscholastic_grade }} Point Scale)</v-col>
                                </strong>
                            </span>
                        </v-row>
                        <v-row dense justify="center" v-if="leraner_marksheet.cograde_details.length > 0">
                            <v-simple-table fixed-header dense class="elevation-1" style="width: 400px;">
                                <thead>
                                    <tr>
                                        <td class="">
                                            <center>Sr.No.</center>
                                        </td>
                                        <td class="">
                                            <center>Grade Name</center>
                                        </td>
                                        <td class="">
                                            <center>Grade Point</center>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(s, index) in leraner_marksheet.cograde_details" :key="s.g_id">
                                        <td>
                                            <center>{{ index + 1 }}</center>
                                        </td>
                                        <td>
                                            <center>{{ s.gradename }}</center>
                                        </td>
                                        <td>
                                            <center>{{ s.range }}</center>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-row>
                        <v-col cols="12" sm="12" md="12" class="tech-remark">
                            1. Students must obtain the qualifying grade (minimum grade D) in all subjects under
                            Scholastic & Co-Scholastic areas.<br />
                            2. D* indicates Conditionally Promoted.
                        </v-col>
                    </div>
                </v-row>
            </v-container>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
  import axios from "axios";
  import jsPDF from "jspdf";
  import "jspdf-autotable";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
      props: {
          org: Number,
      },
      data() {
          return {
              default_value: [],
              dialog_marks: false,
              overlay: false,
              selected: [],
              snackbar: false,
              search: "",
              snackbar_msg: "",
              color: "",
              snackbar: false,
              ay_std_div_list: null,
              sel_ay_data: null,
              semester_list: null,
              sem: null,
              fetch_loader: false,
              show: false,
              course_list: [],
              stud_list: [],
              awspath: "",
              registration_no: null,
              standard: null,
              div: null,
              ay: null,
              name: null,
              dob: null,
              roll_no: null,
              mobile_no: null,
              address: null,
              mother_name: null,
              photo: null,
              reg_no: null,
              gr_no: null,
              father_full_name: null,
              leraner_marksheet: [],
              semester: null,
              colspan: null,
              overall_grade: null,
              remark: [],
              org_basic_data: [],
              sem1: null,
              sem2: null,
              mother_contact: null,
              father_contact: null,
          };
      },

      methods: {
          print() {
              this.$store.state.drawer = false;
              let that = this;
              window.onafterprint = function () {
                  that.$store.state.drawer = true;
              };
              setTimeout(function () {
                  window.print();
              }, 100);
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          onload() {
              this.overlay = true;
              const data = {
                  lid: this.registration_no,
                  ay: this.sel_ay_data,
                  sem: this.sem,
                  org: this.org,
              };
              axios
                  .post("/Examination/getAnnualStudentReport", data)
                  .then((res) => {
                      if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                          this.overlay = false;
                          return;
                      }
                      if (res.data.flag == "YES") {
                          this.standard = res.data.standard;
                          this.div = res.data.div;
                          this.ay = res.data.ay;
                          this.name = res.data.name;
                          this.dob = res.data.dob;
                          this.roll_no = res.data.roll_no;
                          this.mobile_no = res.data.mobile_no;
                          this.address = res.data.address;
                          this.mother_name = res.data.mother_name;
                          this.photo = res.data.photo;
                          this.reg_no = res.data.reg_no;
                          this.gr_no = res.data.gr_no;
                          this.father_full_name = res.data.father_full_name;
                          this.leraner_marksheet = res.data.leraner_marksheet;
                          // console.log(this.leraner_marksheet)
                          this.semester = res.data.semester;
                          this.default_value = res.data.default_value;
                          this.org_basic_data = res.data.org_basic_data;
                          this.mother_contact = res.data.mother_contact;
                          this.father_contact = res.data.father_contact;
                          this.overlay = false;
                      }
                      if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                          this.overlay = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                      this.overlay = false;
                  })
                  .finally(() => {});
          },
      },
      mounted() {
          this.awspath = localStorage.getItem("awspath");
          // this.sel_ay_data = this.$store.getters.ay;
          // this.registration_no = this.$store.getters.reg_no;
          // this.sem = this.$store.getters.sem;
          this.sel_ay_data = localStorage.getItem("setay");
          this.sem = localStorage.getItem("setsem");
          this.registration_no = localStorage.getItem("setreg_no");
          this.onload();
      },
  };
</script>
<style scoped>
  .text_report {
      border: 3px solid black;
      margin: 1rem !important;
  }
  thead {
      font-weight: bold !important;
  }
  th {
      font-weight: bold !important;
  }
  tr,
  td,
  th {
      border: 1px solid black;
      /* text-align: center; */
      font-size: small;
  }
  tr,
  tbody {
      border-bottom: 1px solid black;
      border: 1px solid black;
      font-size: small;
  }
  td {
      font-size: small;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
          font-size: small;
      }
      td + td,
      th + th {
          width: auto;
          font-size: small;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      /* text-align: center; */
      font-size: small;
  }
  .radiospace {
      margin: 1rem !important;
      padding: 0%;
  }
  .btn-css {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #fff !important;
      text-decoration: underline;
      color: #0f2027 !important;
      text-align: left;
  }

  .btn-css:hover {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #ffff !important;
      color: #0f2027 !important;
      text-decoration: underline;
      text-align: left;
  }
  .t-row {
      padding: 1rem i !important;
  }

  .delete-avatar {
      transition: 0.3s;
      border: 1px solid red;
      margin: 0.2rem !important;
  }
  .delete-avatar:hover {
      background-color: transparent;
  }
  .delete-v-icon {
      padding-left: 8px;
      padding-top: 1px;
      font-size: 15px;
  }
  .delete-v-icon:hover {
      color: white;
  }
  .v-dialogss {
      bottom: 880;
      right: 0;
  }
  @page {
      size: A4;
      margin-top: 0;
      padding-top: none;
      size: 11in 15.5in;
  }
  @page :first {
      margin-top: 0mm;
  }
  @media print and (-webkit-min-device-pixel-ratio: 0) {
     .v-data-table__wrapper {
          overflow-x: hidden;
          overflow-y: hidden;
      }
      .card {
          border: none !important;
          font-size: large !important;
      }
                .full-height {
                    height: 93vh;
                }
      /* .scaled {
      transform: scale(1, 1)  !important;; 
      transform-origin: left  !important;;
      } */
      .pagebreak {
          page-break-before: always;
      }
      header,
      footer,
      nav,
      date {
          display: none !important;
      }

      table,
      td,
      tr {
          break-inside: avoid-page;
          page-break-inside: auto;
      }
      /* img {
          width: 100% !important;
      } */
      body,
      tr,
      th,
      td {
          font-size: 22px !important;
          page-break-inside: auto;
          padding: 0 !important;
          word-wrap: break-word;
          margin: 0 !important;
      }
      td {
          font-size: 22px !important;
          word-wrap: break-word;
          padding: 1mm !important;
      }
      .sub-td {
          text-align: left;
      }
      .no-display,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }
      v-card {
          border: none !important;
      }

      thead {
          font-weight: bold !important;
      }
      table,
      tr,
      th {
          text-align: center !important;
          margin-top: none;
          padding: none !important;
          border-bottom: 1px solid black;
          border: 1px solid black;
          page-break-inside: auto;
      }
      .div {
          width: 1450px !important;
          font-size: small;
          margin: 0 !important;
          border: 0px solid black;
      }
  }
  ol.s {
      list-style-type: inherit;
  }
  .stud-info strong {
      margin-left: 20px;
  }
  .stud-info {
      font-size: 22px !important;
  }
  .tech-remark {
      font-size: 22px !important;
  }
</style>
